'use strict';

module.exports = '5.0.4';
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/version.js
// module id = N68W
// module chunks = 0